<template>
    <div :class="`multiple-choice multiple-choice-align-${align}`">
        <label :for="componentId">
            {{ fieldLabel }}
            <span v-if="showAsterisk" style="color: red;">*</span>
        </label>
        <div class="checkbox-group">
            <div v-for="(item, index) in items" :key="itemIds[index]" class="checkbox-wrapper">
                <input
                    type="checkbox"
                    :id="itemIds[index]"
                    :name="componentId"
                    :value="item"
                    :checked="selectedValues.some(val => val.value === item && val.id === itemIds[index])"
                    @change="updateSelection(item, $event, itemIds[index])"
                />
                <label :for="itemIds[index]">{{ item }}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MultipleSelection",
    props: {
        fieldLabel: {
            type: String,
            required: true,
        },
        align: {
            type: String,
            default: "top",
        },
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array,
            default: () => [],
        },
        showError: {
            type: Boolean,
            default: false,
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            selectedValues: [],
            componentId: `multiple-choice-${Math.random().toString(36).substring(2, 15)}`,
            itemIds: []
        };
    },
    computed: {
        showAsterisk() {
            return this.isRequired && this.showError && this.selectedValues.length === 0;
        }
    },
    methods: {
        generateItemIds() {
            this.itemIds = this.items.map((_, index) => `checkbox-${this.componentId}-${index}`);
        },
        updateSelection(item, event, itemId) {
            if (event.target.checked) {
                this.selectedValues.push({
                    value: item,
                    id: itemId
                });
            } else {
                this.selectedValues = this.selectedValues.filter(val => val.id !== itemId);
            }
            this.emitSelected();
        },
        emitSelected() {
            const values = this.selectedValues.map(item => item.value);
            this.$emit("input", values);
            this.$emit("validate", {
                fieldId: this._uid,
                hasError: this.isRequired && values.length === 0,
            });
        }
    },
    created() {
        this.generateItemIds();
        if (this.value && this.value.length > 0) {
            this.selectedValues = this.value.map((val, index) => ({
                value: val,
                id: this.itemIds[index]
            }));
        }
    },
};
</script>

<style scoped lang="scss">
.multiple-choice-align-top, .multiple-choice-align-left, .multiple-choice {
    .checkbox-wrapper {
        position: relative;

        &.error input {
            border: 1px solid red;
        }

        .error-message {
            color: red;
            font-size: 10px;
            position: absolute;
            bottom: -18px;
            left: 0;
        }
    }

    label {
        font-size: 18px;
        font-weight: normal;
        color: #2c3e50;
    }
}

.multiple-choice-align-left {
    display: flex;
    align-items: center;

    > label {
        font-size: 16px !important;
        width: 150px !important;
        text-align: left;
        margin-right: 5px;
    }

    .checkbox-group {
        margin-top: 0px !important;
        display: flex;
        gap: 8px;
    }
}

.multiple-choice-align-right {
    display: flex;
    align-items: center;

    > label {
        font-size: 16px !important;
        width: 150px !important;
        text-align: right;
        margin-right: 5px;
    }

    .checkbox-group {
        margin-top: 0px !important;
        width: 100%;
        display: flex;
        gap: 8px;
    }
}

.multiple-choice {
    max-width: 600px;
    margin: 10px auto;
    text-align: left;

    .checkbox-group {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        @media (max-width: 600px) {
            flex-direction: column;
        }
    }

    .checkbox-wrapper {
        display: flex;
        align-items: center;

        input[type="checkbox"] {
            margin-right: 8px;
        }

        label {
            font-size: 16px;
            color: #8696a0;
        }
    }
}
</style>